<template>
  <Modal name="DELETE_HAUSEFUL_USER_MODAL" :title="title" :width="600" actions>
    <template v-slot:body>
      <h-loading v-if="isHausefulUserLoading" />

      <div v-else>
        <p class="body-2">
          {{ $t('hausefulUsers.hints.delete') }}
        </p>
        <v-card color="grey lighten-3" class="pa-5" elevation="0">
          <h6 class="text-uppercase grey--text">
            {{  $t('hausefulUsers.label.name') }}
          </h6>
          <p class="body-2">
            {{ hausefulUser.name }}
            <span class="d-block caption grey--text">
              {{ formatDocument(hausefulUser.cpf) }}
            </span>
          </p>

          <v-row>
            <v-col class="py-0" cols="12" sm="8">
              <h6 class="text-uppercase grey--text">
                {{  $t('hausefulUsers.label.email') }}
              </h6>
              <p class="body-2">
                {{ hausefulUser.username }}
              </p>
            </v-col>
            <v-col class="py-0" cols="12" sm="4">
              <h6 class="text-uppercase grey--text">
                {{  $t('hausefulUsers.label.type') }}
              </h6>
              <p class="body-2">
                {{ $t(`roles.${hausefulUser.user_type}`) }}
              </p>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex">
        <v-btn
          @click="closeAllModals"
          :disabled="isHausefulUserDeleting"
          class="grey--text mr-5"
          elevation="0"
          large
          text
        >
          {{ $t('hausefulUsers.action.cancel') }}
        </v-btn>

        <v-btn
          @click="deleteUser"
          :loading="isHausefulUserDeleting"
          color="red"
          elevation="0"
          large
          dark
        >
          {{ $t('hausefulUsers.action.delete') }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { formatDocument } from '@/util/document'

export default {
  name: 'HausefulUsersDeleteModal',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters([
      'hausefulUser',
      'isHausefulUserLoading',
      'isHausefulUserDeleting',
    ])
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['deleteHausefulUser']),

    deleteUser() {
      this.deleteHausefulUser(this.hausefulUser.id)
    },
  },

  data() {
    return {
      formatDocument,
      title: this.$t('hausefulUsers.action.delete')
    }
  }
}
</script>
